/** Formato de fechas para la agenda (hora local del dispositivo). */
const DAY = 24 * 60 * 60 * 1000;

export const formatTime = (iso: string) => new Date(iso).toLocaleTimeString('es', { hour: '2-digit', minute: '2-digit' });

export function formatDayHeading(date: Date, now = new Date()): string {
  const start = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
  const diff = Math.round((start(date) - start(now)) / DAY);
  const label = date.toLocaleDateString('es', { weekday: 'long', day: 'numeric', month: 'long' });
  if (diff === 0) return `Hoy · ${label}`;
  if (diff === 1) return `Mañana · ${label}`;
  return label.charAt(0).toUpperCase() + label.slice(1);
}

export const dayKey = (iso: string) => {
  const d = new Date(iso);
  return `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`;
};

/** Agrupa elementos ordenados por fecha en días locales. */
export function groupByDay<T extends { startsAt: string }>(items: readonly T[]): { key: string; date: Date; items: T[] }[] {
  const groups: { key: string; date: Date; items: T[] }[] = [];
  for (const item of items) {
    const key = dayKey(item.startsAt);
    const last = groups.at(-1);
    if (last?.key === key) last.items.push(item);
    else groups.push({ key, date: new Date(item.startsAt), items: [item] });
  }
  return groups;
}

/** Valor para <input type="datetime-local"> en hora local. */
export function toLocalInput(date: Date): string {
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

/** Lee un <input type="datetime-local"> (hora local) y devuelve ISO UTC. */
export const fromLocalInput = (value: string) => new Date(value).toISOString();

export const addDays = (date: Date, days: number) => new Date(date.getTime() + days * DAY);
